import { useMemo } from 'react';
import { Theme, useMediaQuery } from '@planne-software/uni/mui/material';

import { useAppSelector } from '@src/core/hooks';
import { orderVouchersSelector } from '@src/features/orders/store/order';
import { filterVouchersBySaleItem, summarizeVouchers, resolveVoucherDownloadPlacement } from '@src/domains/vouchers';

interface Params {
  orderId: string;
  saleItemId: string;
  hasMultipleVouchers: boolean;
}

export function useReservationVouchers({ orderId, saleItemId, hasMultipleVouchers }: Params) {
  const orderVouchers = useAppSelector(orderVouchersSelector(orderId));
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  const vouchers = useMemo(() => filterVouchersBySaleItem(orderVouchers, saleItemId), [orderVouchers, saleItemId]);

  const summary = useMemo(() => summarizeVouchers(vouchers), [vouchers]);

  const downloadPlacement = useMemo(
    () => resolveVoucherDownloadPlacement({ vouchers, hasMultipleVouchers, isMobile }),
    [vouchers, hasMultipleVouchers, isMobile],
  );

  return { vouchers, summary, downloadPlacement };
}
